var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms",
    transform: "translate(3438 -5635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    transform: "translate(-3438 5635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sms-2",
    "data-name": "sms",
    transform: "translate(-3429 5644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M75.5,89.865A37.663,37.663,0,0,1,62.226,118.6V61.13A37.663,37.663,0,0,1,75.5,89.865Zm-75.5,0A37.663,37.663,0,0,0,13.271,118.6V61.13A37.663,37.663,0,0,0,0,89.865Z",
    transform: "translate(0 -52.116)",
    fill: "#ff73a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M131.9,2.949v62.21a37.952,37.952,0,0,1-4.424,3.6v-.927a1.475,1.475,0,0,0-1.475-1.475H85.9a1.475,1.475,0,0,0-1.475,1.475v.926A37.939,37.939,0,0,1,80,65.159V2.949A2.949,2.949,0,0,1,82.949,0h46.006A2.949,2.949,0,0,1,131.9,2.949Z",
    transform: "translate(-68.204)",
    fill: "#9650aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M197.1,21.475a1.475,1.475,0,0,1-1.475,1.475h-8.847a1.475,1.475,0,0,1,0-2.949h8.847A1.475,1.475,0,0,1,197.1,21.475ZM181.475,20a1.475,1.475,0,1,0,1.475,1.475A1.475,1.475,0,0,0,181.475,20Zm19.169,0a1.475,1.475,0,1,0,1.475,1.475A1.475,1.475,0,0,0,200.644,20Z",
    transform: "translate(-153.458 -17.051)",
    fill: "#64326e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M153.057,61.475V71.8a1.475,1.475,0,0,0-1.475-1.475H111.475A1.475,1.475,0,0,0,110,71.8V61.475A1.475,1.475,0,0,1,111.475,60h40.108A1.475,1.475,0,0,1,153.057,61.475Z",
    transform: "translate(-93.78 -51.153)",
    fill: "#afebd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M153.057,99.475v52.832a37.752,37.752,0,0,1-43.057,0V99.475A1.475,1.475,0,0,1,111.475,98h40.108A1.475,1.475,0,0,1,153.057,99.475Z",
    transform: "translate(-93.78 -83.549)",
    fill: "#e6faff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M49.678,225.425H59.932A13.678,13.678,0,0,1,73.609,239.1v16.548a2.889,2.889,0,0,1-2.889,2.889h0a2.888,2.888,0,0,1-2.539-1.511l-2.306-4.249h-16.2A13.678,13.678,0,0,1,36,239.1h0A13.678,13.678,0,0,1,49.678,225.425Z",
    transform: "translate(-30.692 -192.185)",
    fill: "#6cd0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M103.271,278.737v2.949a.737.737,0,0,1-.737.737h-11.8a.737.737,0,0,1-.737-.737v-2.949a.737.737,0,0,1,.737-.737h11.8A.737.737,0,0,1,103.271,278.737Zm-5.161,6.635H90.737a.737.737,0,0,0-.737.737v2.949a.737.737,0,0,0,.737.737H98.11a.737.737,0,0,0,.737-.737V286.11A.737.737,0,0,0,98.11,285.373Z",
    transform: "translate(-76.729 -237.007)",
    fill: "#4191be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M258.553,133.679h0a13.678,13.678,0,0,1-13.678,13.678h-16.2l-2.306,4.249a2.889,2.889,0,0,1-2.539,1.511h0a2.889,2.889,0,0,1-2.889-2.889V133.679A13.678,13.678,0,0,1,234.622,120h10.254A13.678,13.678,0,0,1,258.553,133.679Z",
    transform: "translate(-188.365 -102.306)",
    fill: "#ffe13c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M307.695,170.737v2.949a.737.737,0,0,1-.737.737h-16.22a.737.737,0,0,1-.737-.737v-2.949a.737.737,0,0,1,.737-.737h16.22A.737.737,0,0,1,307.695,170.737Zm-.737,6.635H294.424a.737.737,0,0,0-.737.737v2.949a.737.737,0,0,0,.737.737h12.534a.737.737,0,0,0,.737-.737V178.11A.737.737,0,0,0,306.957,177.373Z",
    transform: "translate(-247.238 -144.933)",
    fill: "#ebb410"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.28738c17480efbb406e11debe05410e3.svg";
export { ForwardRef as ReactComponent };